/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */
import React, { useCallback, useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { SessionContext } from '../../../../../context/SessionContext';
import {
  TelemetryAction,
  TelemetryComponent,
  TelemetryState,
  useSendTelemetry,
} from '../../../../../hooks/useSendTelemetry';
import { buildGoToOpenerJoinUrl } from '../../../../../services/UrlService';
import { ButtonOverDescription } from '../../../../ButtonOverDescription/ButtonOverDescription';

interface Props {
  onStartButtonClick: () => void;
}

const messages = defineMessages({
  nativeStartButton: {
    id: 'secondJoinManualNativeIJ.nativeStartButton',
  },
  nativeStartDescription: {
    id: 'secondJoinManualNativeIJ.nativeStartDescription',
  },
});

export const NativeStartJoinOption: React.FC<Props> = (props) => {
  const { onStartButtonClick } = props;
  const sendJoinLaunchTelemetry = useSendTelemetry();
  const { formatMessage: f } = useIntl();
  const { openerLaunchToken } = useContext(SessionContext);
  const handleNativeStartClick = useCallback(() => {
    sendJoinLaunchTelemetry(
      TelemetryComponent.Native,
      TelemetryAction.Join,
      TelemetryState.SecondManual
    );
    onStartButtonClick();
  }, [onStartButtonClick, sendJoinLaunchTelemetry]);

  return (
    <ButtonOverDescription
      link={buildGoToOpenerJoinUrl(openerLaunchToken)}
      handleClick={handleNativeStartClick}
      buttonText={f(messages.nativeStartButton)}
      description={f(messages.nativeStartDescription)}
    />
  );
};
